module.exports = __webpack_public_path__ + "static/back-of-openbci-84827401b156eafbdb61fb9e057c9238.jpg";